// const BASE_URL = process.env.REACT_APP_BASE_URL;

// export const endpoints = {
//   REGISTER_API: BASE_URL + "/auth/register",
//   REGISTER_OTP_SEND : BASE_URL + "/auth/register-otp/send-otp",
//   VERIFY_OTP : BASE_URL + "/auth/verify-register-otp/verify-otp",
//   LOGIN_API: BASE_URL + "/auth/login",
//   FORGOTPASSWORD_SENDOTP_API: BASE_URL + "/auth/forgot-password/send-otp",
//   FORGOTPASSWORD_VERIFYOTP_API: BASE_URL + "/auth/forgot-password/verify-otp",
//   RESETPASSWORD_API: BASE_URL + "/auth/forgot-password/reset-password",
// };

// export const artistProfilePoints = {
//   FETCH_PROFILE_DATA_API: BASE_URL + "/artists/profile",
//   UPDATE_PROFILE_DATA_API: BASE_URL + "/artists/profile",
//   UPDATE_ARTIST_AVATAR_API: BASE_URL + "/artists/profile/avatar",
//   LOGIN_WITH_GOOGLE_API: BASE_URL + "/auth/google",
//   UPLOAD_PERF_IMAGES: BASE_URL + "/artists/profile/perf-images",
//   UPLOAD_PERF_VIDEOS: BASE_URL + "/artists/profile/perf-videos",
// };

// export const artistOpportunityPoints = {
//   FETCH_OPPOR_DATA_API: BASE_URL + `/artists/opportunities`,
//   APPLY_OPPOR_API: BASE_URL + `/artists/applications`,
//   RETRIVE_APPLIED_APPLI: BASE_URL + `/artists/opportunities`,
//   FETCH_OPPOR_BY_ID: BASE_URL + `/artists/opportunities`,
//   SAVE_OPPR_BY_ID: BASE_URL + `/artists/saved-opportunities`,
// };

// export const statusOfAppliPoints = {
//   FETCH_APPLIED_APPLI_API: BASE_URL + `/artists/applications`,
//   FETCH_SAVED_APPLI_API: BASE_URL + `/artists/saved-opportunities`,
// };

// export const patronProfilePoints = {
//   FETCH_PATRON_APPLI_API: BASE_URL + `/patrons/profile`,
//   UPLOAD_OPPOR_API: BASE_URL + `/patrons/opportunities`,
//   FETCH_PATRON_APPLI_OPPOR_API: BASE_URL + `/patrons/opportunities`,
//   FETCH_PATRON_ALL_APPLI_API: BASE_URL + `/patrons/opportunities/applications`,
//   FETCH_SINGLE__APPLI_API: BASE_URL + `/patrons/opportunities/applications`,
//   GET_PATRON_APPLI_API: BASE_URL + `/patrons/opportunities`,
//   UPDATE_OPPOR_API: BASE_URL + `/patrons/opportunities`,
//   GET_SINGLE_OPPOR_ALL_APPLIED_ARTIST_APPLI_API:
//     BASE_URL +
//     `/patrons/opportunities/applications?status=Applied&opportunityId=`,
//   GET_SINGLE_OPPOR_ALL_IN_PROGRESS_ARTIST_APPLI_API:
//     BASE_URL +
//     `/patrons/opportunities/applications?status=In-Progress&opportunityId=`,
//   GET_SINGLE_OPPOR_ALL_HIRED_ARTIST_APPLI_API:
//     BASE_URL +
//     `/patrons/opportunities/applications?status=Hired&opportunityId=`,
//   GET_SINGLE_ARTIST_DATA_API: BASE_URL + `/patrons/artists/`,
//   HIRED_REJECT_SHORTLIST_ARTIST_API:
//     BASE_URL + `/patrons/opportunities/applications`,
//   PATRON_AVATAR_UPDATE: BASE_URL + "/patrons/profile/avatar",
// };
// export const Admin = {
//   GET_ALL_USERS: BASE_URL + `/admin/users`,
//   GET_USER_BY_ID: BASE_URL + `/admin/users/`,
//   GET_ARTIST_APPLICANTS: BASE_URL + `/admin/users/artist/`,
// };

// export const contactUsPoints = {
//   POST_QUERY_API: BASE_URL + `/quries/post-query`,
// };

// //try


const BASE_URL = process.env.REACT_APP_BASE_URL;
console.log("BASE_URL =", BASE_URL);   // <-- add this line

export const endpoints = {
  REGISTER_API: BASE_URL + "/auth/register",
  REGISTER_OTP_SEND : BASE_URL + "/auth/register-otp/send-otp",
  VERIFY_OTP : BASE_URL + "/auth/verify-register-otp/verify-otp",
  LOGIN_API: BASE_URL + "/auth/login",
  LOGIN_WITH_EMAIL: BASE_URL + "/auth/login-with-email",
  FORGOTPASSWORD_SENDOTP_API: BASE_URL + "/auth/forgot-password/send-otp",
  FORGOTPASSWORD_VERIFYOTP_API: BASE_URL + "/auth/forgot-password/verify-otp",
  RESETPASSWORD_API: BASE_URL + "/auth/forgot-password/reset-password",
};

export const artistProfilePoints = {
  FETCH_PROFILE_DATA_API: BASE_URL + "/artists/profile",
  UPDATE_PROFILE_DATA_API: BASE_URL + "/artists/profile",
  UPDATE_ARTIST_AVATAR_API: BASE_URL + "/artists/profile/avatar",
  LOGIN_WITH_GOOGLE_API: BASE_URL + "/auth/google",
  UPLOAD_PERF_IMAGES: BASE_URL + "/artists/profile/perf-images",
  UPLOAD_PERF_VIDEOS: BASE_URL + "/artists/profile/perf-videos",
};

export const artistOpportunityPoints = {
  FETCH_OPPOR_DATA_API: BASE_URL + `/artists/opportunities`,
  APPLY_OPPOR_API: BASE_URL + `/artists/applications`,
  RETRIVE_APPLIED_APPLI: BASE_URL + `/artists/opportunities`,
  FETCH_OPPOR_BY_ID: BASE_URL + `/artists/opportunity`,
  SAVE_OPPR_BY_ID: BASE_URL + `/artists/saved-opportunities`,
};

export const statusOfAppliPoints = {
  FETCH_APPLIED_APPLI_API: BASE_URL + `/artists/applications`,
  FETCH_SAVED_APPLI_API: BASE_URL + `/artists/saved-opportunities`,
};

export const patronProfilePoints = {
  FETCH_PATRON_APPLI_API: BASE_URL + `/patrons/profile`,
  FETCH_PATRON_PROFILE_API: BASE_URL + `/patrons/patronprofile`,
  UPLOAD_OPPOR_API: BASE_URL + `/patrons/opportunities`,
  FETCH_PATRON_ALL_ARTIST_API: BASE_URL + `/patrons/artists`,
  FETCH_PATRON_OPPOR_API: BASE_URL + `/patrons/opportunities`,
  FETCH_PATRON_ALL_APPLI_API: BASE_URL + `/patrons/opportunities/applications`,
  SHORTLIST_APPLI_API: BASE_URL + `/patrons/opportunities/applications/shortlist`,
  HIRED_APPLI_API: BASE_URL + `/patrons/opportunities/applications/hire`,
  FETCH_SINGLE__APPLI_API: BASE_URL + `/patrons/opportunities/applications`,
  GET_PATRON_APPLI_API: BASE_URL + `/patrons/opportunities`,
  UPDATE_OPPOR_API: BASE_URL + `/patrons/opportunities`,
  GET_SINGLE_OPPOR_ALL_APPLIED_ARTIST_APPLI_API: BASE_URL +
    `/patrons/opportunities/applications?&opportunityId=`,
  GET_SINGLE_OPPOR_ALL_IN_PROGRESS_ARTIST_APPLI_API:
    BASE_URL +
    `/patrons/opportunities/applications?status=In-Progress&opportunityId=`,
  GET_SINGLE_OPPOR_ALL_HIRED_ARTIST_APPLI_API:
    BASE_URL +
    `/patrons/opportunities/applications?status=Hired&opportunityId=`,
  GET_SINGLE_ARTIST_DATA_API: BASE_URL + `/patrons/artists/`,
  HIRED_REJECT_SHORTLIST_ARTIST_API:
    BASE_URL + `/patrons/opportunities/applications`,
  INVITE_ARTIST_API: BASE_URL + `/patrons/opportunities/invite`,
  PATRON_AVATAR_UPDATE: BASE_URL + "/patrons/profile/avatar",
  CREATE_PERFORMANCE_API: BASE_URL + "/patrons/performances",
  GET_PERFORMANCE_API: BASE_URL + "/patrons/performance/",
  GET_USER_PERFORMANCES_API: BASE_URL + "/patrons/performances",
  UPDATE_PERFORMANCE_API: BASE_URL + "/patrons/performances",
  UPLOAD_PERFORMANCE_IMAGES_API: BASE_URL + "/patrons/performance-images",
};

export const performancePoints = {
  GET_ALL_PERFORMANCES: BASE_URL + `/performances/all`,
  DELETE_PERFORMANCE: BASE_URL + `/performances/delete`,
  UPDATE_ARTIST_AMOUNT: BASE_URL + `/performances/admin-edit/amount`
} 

export const reviewPoints = {
  GET_REVIEWS_BY_PRODUCT: BASE_URL + `/reviews/product/`,
  GET_REVIEWS_BY_ARTIST: BASE_URL + `/reviews/artist`,
}


export const Admin = {
  GET_ALL_USERS: BASE_URL + `/admin/users`,
  GET_USER_BY_ID: BASE_URL + `/admin/users/`,
  GET_ARTIST_APPLICANTS: BASE_URL + `/admin/users/artist/`,
  GET_ALL_APPLICANTS: BASE_URL + `/admin/allapps`,
  DELETE_APPLICANTS: BASE_URL + `/admin/deleteapp`,
};

export const contactUsPoints = {
  POST_QUERY_API: BASE_URL + `/quries/post-query`,
};

export const quotePoints = {
  QUOTE_API: BASE_URL + `/quote`,
};

export const partnerPoints = {
  FETCH_PARTNER_OFFERINGS_API: BASE_URL + `/partner/products`,
  FETCH_PUBLIC_PARTNER_OFFERINGS_API: BASE_URL + `/partner/public/products`,
  PUSH_PARTNER_CART_ITEM: BASE_URL + `/partner/cartitem`,
  GET_PARTNER_CART_ITEM: BASE_URL + `/partner/cart`,
  DELETE_PARTNER_CART_ITEM: BASE_URL + `/partner/cart/delete`,
  GET_PARTNER_CART_ITEMS: BASE_URL + `/partner/cart`,
  DELETE_ALL_PARTNER_CART_ITEMS: BASE_URL + `/partner/cart/delete/all`,
};


export const productPoints = {
  UPLOAD_PRODUCTS_API : BASE_URL +  `/products`,
  FETCH_ALL_PRODUCTS_API_ADMIN: BASE_URL + `/products/admin/all`,
  FETCH_PUBLIC_PRODUCTS_API : BASE_URL +  `/products/public`,
  FETCH_PUBLIC_ONE_PRODUCTS_API : BASE_URL +  `/products/public`,
  FETCH_ARTIST_PRODUCT:BASE_URL + `/products`,
  EDIT_PRODUCTS_API : BASE_URL +  `/products`,
  DELETE_PRODUCTS_API : BASE_URL +  `/products`,
  PUSH_CART_ITEMS: BASE_URL + `/products/cartitem`,
  DELETE_CART_ITEM: BASE_URL + `/products/cartitem/delete`,
  DELETE_ALL_CART_ITEMS: BASE_URL + `/products/cartitems/delete/all`,
  GET_CART_ITEM: BASE_URL + `/products/cartitems`
}

export const orderPoints = {
  CREATE_ORDER_API : BASE_URL + `/orders`,
  FETCH_USER_ORDERS_API : BASE_URL + `/orders/my-orders`,
  FETCH_SINGLE_ORDER_API : BASE_URL + `/orders`,
  FETCH_ADMIN_ORDERS_API : BASE_URL + `/orders/admin/orders`,
  UPDATE_ORDER_STATUS_API : BASE_URL + `/orders/admin`,
  FETCH_ALL_ARTIST_ORDER_API : BASE_URL + `/orders/seller/my-orders`
}

//try
